module.exports = __webpack_public_path__ + "static/media/profpagebanner.65944da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profpagebanner.png
// module id = 1339
// module chunks = 0